import axiosInstance from "./axiosInstance";

import { toast } from "react-toastify";
 

import { locationUser } from "../Redux/action/userActions";


export const spocLogin = () => async (dispatch) => {
  const authToken = localStorage.getItem("token");
 
  if (!authToken) {
    console.error("No token found. User is not authenticated.");
    return;
  }
 
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/user/spoc_login_v2`,
      {}, // Empty body
      {
        headers: {
          Authorization: `${authToken}`,
          Cookie: "jwtToken=undefined", // Optional if needed
        },
      }
    );
 
    if (response.data.status === 200) {
      // Reset the redirection flag on successful login
      localStorage.removeItem("noAccessRedirected");
 
      const headData = response.data.data.data;
      headData.spintlyToken = response.data.data.spintlyToken;
      headData.organizationId = response.data.data.coreUser.members[0].organization.id;
      headData.clientCrmId = response.data.data.coreUser.members[0].organization.crm_id;
      headData.companyWiseBooking = response.data.data.coreUser.members[0].organization.service_customization;
      headData.coreUser = response.data.data.coreUser;
      headData.roomShared = response.data.data.coreUser.members[0].organization.type;
 
      // Store data in localStorage
      localStorage.setItem("bannerStatus", "Yes");
      localStorage.setItem("headData", JSON.stringify(headData));

      await locationUser({
        params: { spoc: headData.rec_id, client: headData.company_id },
        headers: { Authorization: headData.spintlyToken },
      });

      // Prevent infinite reload by setting a flag
      if (!localStorage.getItem("reloaded")) {
        localStorage.setItem("reloaded", "true"); // Mark the page as reloaded
        window.location.href = window.location.href; // Trigger a single reload
      }
    }
    else if (response.data.data.status === 401) {
 
        toast.error(response.data.data.status_message);
      // Prevent infinite reload: Redirect only if the user hasn't been redirected yet
      if (!localStorage.getItem("noAccessRedirected")) {
        localStorage.setItem("noAccessRedirected", "true");
        window.location.href = "/no-access";
      }
    }
    else {
      toast.error(response.data.status_message, {});
    }
  } catch (error) {
    console.error("API call failed", error);
  }
};
 